import React from "react";

function RequestLoader() {
  return (
    <div className="animate-spin rounded-full mx-auto h-[30px] w-[30px] border-2 border-r-0 border-b-0 border-[#fff]"></div>
  );
}

export default RequestLoader;
